import './ListPicker.scss';

export const ListPicker = ({ question, options, onOptionChange, selectedOption }) => {
  return (
    <div className="list-picker">
      <div className="question">{question}</div>
      <select value={selectedOption} onChange={(e) => onOptionChange(e.target.value)}>
        <option value="" disabled>
          Please Select
        </option>
        {options.map((option, index) => (
          <option key={index} className={`option ${selectedOption === option ? 'selected' : ''}`} onClick={() => onOptionChange(option)}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};
